import { toast, cssTransition } from "react-toastify";
import './toastUtils.css'

const SlideRightToLeft = cssTransition({
  enter: 'toast-slide-enter',
  exit: 'toast-slide-exit',
});

const ToastTimeout = 2500;

export const showSuccessToast = (message: string): void => {
  toast.success(message, {
    position: "bottom-center",
    autoClose: ToastTimeout,
  });
};


//For Mobile
export const showErrorToast = (message: string, toastId?: string,autoClose?: number): void => {
  if (toastId && toast.isActive(toastId)) {
    // A repeat user action (e.g. clicking Pay again) deserves visible
    // feedback even if the previous toast with this id hasn't finished
    // autoClosing yet — refresh it rather than silently dropping the call.
    toast.update(toastId, { render: message, autoClose: ToastTimeout });
    return;
  }
  toast.error(message, {
    position: "top-center",
    autoClose: autoClose ?? ToastTimeout,
    transition: SlideRightToLeft,
    ...(toastId ? { toastId } : {}),
    style: {
      backgroundColor: "var(--primary-color)",
      color: "var(--primary-text-color)",
      fontWeight: "bold",
      borderRadius: "8px",
      fontSize: "14px",
      padding: "12px 16px",
      textAlign: "left",
      zIndex: 9999,
      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    },
  });
};


//For Desktop
export const showErrorToastDesktop = (message: string, toastId?: string,autoClose?: number): void => {
  if (toastId && toast.isActive(toastId)) {
    toast.update(toastId, { render: message, autoClose: ToastTimeout });
    return;
  }
  toast.error(message, {
    position: "top-right",
    autoClose: autoClose ?? ToastTimeout,
    transition: SlideRightToLeft,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    className: "custom-toast-container-desktop",
    ...(toastId ? { toastId } : {}),
    style: {
      backgroundColor: "var(--primary-color)",
      color: "var(--primary-text-color)",
      fontWeight: "bold",
      borderRadius: "8px",
      padding: "12px 16px",
      fontSize: "14px",
      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    },
  });
};
